<template>
  <div class="dynamic-product-list" v-if="dataLoaded">
    <div class="btm-line"></div>
    <dynamic-product
      v-for="(item, index) in products"
      :key="index"
      :data="item"
      :index="index"
      :productCondition="listCondition"
      :miniEnv="miniEnv"
      :productImageHeight="productImageHeight"
      :hideInfoPadding="checkInfoPadding(index)"
      @product-simple="productSimpleJump"
    />
  </div>
</template>

<script>
import dynamicProduct from '@/components/dynamic-product-simple'
import { get } from '@/product'
import { getActivity } from '@/product-activity'
import { lazyload } from '@/lazyload'

export default {
  components: {
    dynamicProduct
  },

  props: {
    dataOrigin: {
      type: String,
      default: 'PRODUCT'
    },
    ids: {
      type: Array,
      default() {
        return []
      },
    },
    listCondition: {
      type: Object,
      default() {
        return {}
      },
    },
    miniEnv: {
      default: false
    },
    originProducts: {
      type: Array,
      default() {
        return []
      },
    },
    listPl: {//仅对部分模块有作用 比如新列表模块
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      productRatio: 330/345,//w/h
      products: null,
      dataLoaded: false,
      productWidth: 0,
      defaultStyle: null,
      productImageHeight: 0
    }
  },

  created () {
    this.formatData()
  },

  methods: {
    formatData () {
      const listCondition = this.listCondition
      console.log(listCondition, "listCondition")
      this.productWidth = (listCondition.listWidth-(listCondition.rowNum-1)*listCondition.lineGap)/listCondition.rowNum
      const productHeight = (this.productWidth/330)*345

      this.productImageHeight = productHeight
      const ratio = this.listCondition.ratio
      const heightObj = {
        imageGap: 10*ratio,
        brandH: 17*ratio,
        productH1: 17*ratio,
        productH2: 34*ratio,
        priceH: 17*ratio
      }
      // let defaultStyle = {
      //   'width': `${this.productWidth}px`,
      //   'height': `${productHeight+imageGap}px`
      // }

      let defaultProductHeight = productHeight+heightObj.imgGap
      if(this.listCondition.brandName === 'SHOW') {
        defaultProductHeight += heightObj.brandH
      }
      if(this.listCondition.productName === 'ONE') {
        defaultProductHeight += heightObj.productH1
      }
      if(this.listCondition.productName === 'TWO') {
        defaultProductHeight += heightObj.productH2
      }
      if(this.listCondition.rawPrice || this.listCondition.nowPrice) {
        defaultProductHeight += heightObj.priceH
      }

      this.defaultStyle = {
        'width': `${this.productWidth}px`,
        'min-height': `${this.defaultProductHeight}px`,
        'margin-bottom': `${this.listCondition.rowGap}px`,
        'margin-left': `${this.listCondition.lineGap}px`
      }

      if(this.originProducts && this.originProducts.length) {
        this.dataLoaded = true
        this.products = this.originProducts
      } else {
        if(this.dataOrigin === 'ACTIVITY') {
          this.getProductsByActivity()
        } else {
          this.getProducts()
        }
      }
    },
    
    getProductsByActivity () {
      this.products = this.ids

      if(!this.ids || this.ids.length === 0) {
        return
      }

      let newIds = []
      this.ids.forEach(id => {
        if(id && !(~newIds.indexOf(id))) {
          newIds.push(id)
        }
      })

      let allArr = []
      let normalArr = []
      let soldOutArr = []
      let offShelfArr = []
      let newProducts = []

      getActivity(newIds, (err, dataMap) => {
        if (err) {
          return
        }
        this.dataLoaded = true

        let products = []
        newIds.forEach((key) => {
          let activity = dataMap[key]
          if(!activity) {
            return
          }
          
          if(activity.products && activity.products.length) {
            products = products.concat(activity.products)
          }
        })

        products.forEach(product => {
          if(!product || product.invisible) {
            return
          }

          // normalArr.push(product)
          // allArr.push(product)

          if(this.listCondition.soldOutCondition === 'ORIGIN' && !product.offShelf) {
            allArr.push(product)
          } else {
            if(product.offShelf) {
              offShelfArr.push(product)
            } else if(product.soldOut) {
              soldOutArr.push(product)
            } else {
              normalArr.push(product)
            }
          }

        })
        if(this.listCondition.soldOutCondition === 'FILTER') {
          newProducts = normalArr
        } else if(this.listCondition.soldOutCondition === 'ORIGIN') {
          newProducts = allArr
        } else if (this.listCondition.soldOutCondition === 'RUSH') {
          newProducts = normalArr.filter(p => {
            return !p.rushSoldOut
          })
        } 
        else {
          newProducts = normalArr.concat(soldOutArr)
        }

        // newProducts = allArr


        this.$nextTick(() => {
          this.products = newProducts
          this.$nextTick(() => {
            lazyload()
          })
        })
      })
    },

    getProducts () {
      this.products = this.ids

      if(!this.ids || this.ids.length === 0) {
        return
      }

      let newIds = []
      this.ids.forEach(id => {
        if(id && !(~newIds.indexOf(id))) {
          newIds.push(id)
        }
      })

      let allArr = []
      let normalArr = []
      let soldOutArr = []
      let offShelfArr = []
      let newProducts = []

      get(newIds, (err, productMap) => {
        if (err) {
          return
        }
        this.dataLoaded = true
        newIds.forEach(id => {
          const product = productMap[id]
          if(!product || product.invisible) {
            return
          }
          product.id = id

          // allArr.push(product)

          if(this.listCondition.soldOutCondition === 'ORIGIN' && !product.offShelf) {
            allArr.push(product)
          } else {
            if(product.offShelf) {
              offShelfArr.push(product)
            } else if(product.soldOut) {
              soldOutArr.push(product)
            } else {
              normalArr.push(product)
            }
          }
        })
        // newProducts = allArr
        if(this.listCondition.soldOutCondition === 'FILTER') {
          newProducts = normalArr
        } else if(this.listCondition.soldOutCondition === 'ORIGIN') {
          newProducts = allArr
        } else if (this.listCondition.soldOutCondition === 'RUSH') {
          newProducts = normalArr.filter(p => {
            return !p.rushSoldOut
          })
        } else {
          newProducts = normalArr.concat(soldOutArr)
        }

        this.$nextTick(() => {
          const p = this.wxFormatProductList(newProducts, [], 0)
          console.log(p.renderList)
          this.products = p.renderList
          this.$nextTick(() => {
            lazyload()
          })
        })
      })
    },

    wxFormatProductList (productsItem, products, increase, pageObj) {
      const tempProductGroup = []
      let isLeft = false // 左右标记
      let isInit = false // 每一轮商品初始化
      let singleProduct = null // 给上一页最后一个空位置预留
      productsItem.forEach((prod, index) => {
        let {
          id,
          sceneImage,
          sceneVideo,
          sceneCover,
          cropListImage,
          cropFeatureImage,
          featureImage,
          price,
          rawPrice,
          refunds,
          activityDesc,
          customizable,
          foretell,
          mainStationFirst,
          name,
          newcomerTag,
          offShelf,
          priceForecast,
          refundsName,
          summary,
          stockWarn,
          soldOut,
          labels,
          copywriter,
          isOversea,
          rush
        } = prod

        const newProd = {
          id,
          sceneImage,
          cropFeatureImage,
          cropListImage,
          featureImage,
          price,
          rawPrice,
          refunds,
          activityDesc,
          customizable,
          foretell,
          mainStationFirst,
          name,
          newcomerTag,
          offShelf,
          priceForecast,
          refundsName,
          summary,
          stockWarn,
          soldOut,
          labels,
          copywriter,
          isOversea,
          sceneImage,
          sceneVideo,
          sceneCover,
          rush
        }

        // 处理一些prod细节
        newProd._cropListImage = formatZipListImage(cropListImage || cropFeatureImage || featureImage)
        if (refunds) {
          newProd._refunds = refunds.toFixed(1)
        }
        newProd._index = increase * 10 + index
        // 处理一些prod细节结束
        let _tempProduct = null // 这事有sceneImage的商品对象
        if (sceneImage || sceneVideo) {
          _tempProduct = Object.assign({
            _isScene: true
          }, newProd)
        }

        // if (!isInit && products.length && !products[products.length - 1][1]) {// 每次分页时上一页最后一组商品是单个的
        //   singleProduct = productsItem.filter(p => {  //获取每次分页的新一轮商品中第一个不带sceneImage的商品
        //     return !p.sceneImage && !p.sceneVideo
        //   })[0]
        //   isInit = true
        // }

        // if (singleProduct && singleProduct.id === newProd.id) { // 分页的商品不处理已经补足上一页最后一组为单数的商品
        //   singleProduct = newProd
        //   return
        // } 
        
        if (!tempProductGroup.length) { // 每一轮开始的判断
          const _newArr = new Array(2)
          _newArr[0] = newProd
          if (_tempProduct) {
            _newArr[1] = _tempProduct
            isLeft = true
          }
          tempProductGroup.push(_newArr)

          return 
        }

        const prevLastGroupProduct = tempProductGroup[tempProductGroup.length - 1] // 取最后一组数据
        const prevLastPos = prevLastGroupProduct[1] // 上一组最后一个数据

        if (_tempProduct && !prevLastPos) { // 是sceneImage && 上一个最后一组数据是单数
          if (isLeft) {
            tempProductGroup[tempProductGroup.length - 1] = [_tempProduct, newProd]
            isLeft = false
          }
          else {
            tempProductGroup[tempProductGroup.length - 1] = [newProd, _tempProduct]
            isLeft = true
          }
          tempProductGroup.push(prevLastGroupProduct)
        }
        else if (_tempProduct && prevLastPos) { // 是sceneImage && 上一个最后一组数据非单数
          if (isLeft) {
            tempProductGroup.push([_tempProduct, newProd])
            isLeft = false
          }
          else {
            tempProductGroup.push([newProd, _tempProduct])
            isLeft = true
          }
        }
        else if (!_tempProduct && !prevLastPos) {
          tempProductGroup[tempProductGroup.length - 1][1] = newProd
        }
        else {
          tempProductGroup.push([newProd, null])
        }
      })

      const renderList = []
      tempProductGroup.forEach(temp => {
        // console.log(111,temp[0],temp[1])
        renderList.push(temp[0])

        if (temp[1]) {
          renderList.push(temp[1])
        }
      })
      return {
        items: tempProductGroup,
        renderList,
        singleProduct
      }
    },

    checkInfoPadding (index) {
      let hidePadFlag = false
      if(!this.listPl) {//模块没有边距，则不隐藏默认的15边距
        hidePadFlag = false
      } else if(this.listCondition.rowNum === 2 && index%2===0) {//模块有边距，每行的第一个隐藏边距
        hidePadFlag = true
      } else if(this.listCondition.rowNum === 3 && index%3===0) {//模块有边距，每行的第一个隐藏边距
        hidePadFlag = true
      }
      // console.log(this.listPl, index, hidePadFlag)
      return hidePadFlag
    },

    productSimpleJump (product, index) {
      console.log(product, index)
      this.$emit('product-simple', product, index)
    },

  },
}
function formatZipListImage (src, width){
  if (src.includes('x-oss-process')) {
    return src
  }
  return `${src}?x-oss-process=image/quality,q_90`
}
</script>

 <style lang="stylus">
  @import '../../common/styl/global.styl'
  @import '../../common/styl/grotesk-font.styl'

  .dynamic-product-list
    position relative
    background #F1F2F4
    .btm-line
      position absolute
      bottom 0
      left 0
      width 100%
      height rem(1)
      background #fff
  .gro-book
    font-family groteskBook
  .gro-demi
    font-family groteskDemi
  .dynamic-product-list
    display flex
    flex-wrap wrap
    // justify-content space-between
      

</style>



// WEBPACK FOOTER //
// index.vue?29243675